// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';

import { User } from '../../../user-management/users/user';

export const LOAD_USER_INFORMATION = '[User] Load user information';
export const LOAD_USER_INFORMATION_SUCCESS =
  '[User] Load user information success';
export const LOAD_USER_INFORMATION_FAIL = '[User] Load user information fail';

export class LoadUserInformation implements Action {
  public readonly type: string = LOAD_USER_INFORMATION;
  constructor(public payload: any = null) {}
}

export class LoadUserInformationSuccess implements Action {
  public readonly type: string = LOAD_USER_INFORMATION_SUCCESS;
  constructor(public payload: User) {}
}

export class LoadUserInformationFail implements Action {
  public readonly type: string = LOAD_USER_INFORMATION_FAIL;
  constructor(public payload: any) {}
}

export type UserInformationActions =
  | LoadUserInformation
  | LoadUserInformationSuccess
  | LoadUserInformationFail;
